<template>
  <div>
    <el-dialog
      class="commonn_dialog"
      :title="dialogTitle"
      :visible.sync="visible"
      :width="popupWidth"
      :top="popupTop"
      :modal-append-to-body="modalAppendToBody"
      :append-to-body="true"
      :fullscreen="dialogFullScreen"
      :destroy-on-close="true"
      @close="Cancel"
    >
      <span v-if="dialogType !== ''" slot="title" class="show-line">
        <img
          v-if="dialogType == 'success'"
          src="../../assets/img/common/icon-sucess@2x.png"
          alt=""
        />
        <img
          v-if="dialogType == 'warning'"
          src="../../assets/img/common/icon-warning@2x.png"
          alt=""
        />
        <i>{{ dialogTitle }}</i>
      </span>
      <p v-if="dialogContent != ''">
        {{ dialogContent }}
      </p>
      <slot v-else>
        <p>弹窗内容自定义</p>
      </slot>
      <span
        v-show="showBtn || onlyShowCancel"
        slot="footer"
        class="dialog-footer"
      >
        <eui-btn v-if="onlyShowCancel" type="secondary" @click="Cancel">{{
          cancelButtonTip
        }}</eui-btn>
        <template v-else>
          <eui-btn v-if="isShowCancel" type="secondary" @click="Cancel">{{
            cancelButtonTip
          }}</eui-btn>
          <eui-btn v-debounce="Save" type="primary">{{ buttonTip }}</eui-btn>
          <div v-show="showTip" class="tip-wrap">
            提交后，可在规格申请菜单查询审核进度，审核通过后才可使用。
          </div>
        </template>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    dialogType: {
      type: String,
      default: '',
    },
    dialogContent: {
      type: String,
      default: '',
    },
    dialogTitle: {
      type: String,
      default: '标题',
    },
    centerDialogVisible: {
      type: Boolean,
      default() {
        return false;
      },
    },
    dialogFullScreen: {
      type: Boolean,
      default() {
        return false;
      },
    },
    popupWidth: {
      type: String,
      default() {
        return '430px';
      },
    },
    popupTop: {
      type: String,
      default() {
        return '23vh';
      },
    },
    showBtn: {
      type: Boolean,
      default() {
        return true;
      },
    },
    onlyShowCancel: {
      type: Boolean,
      default() {
        return false;
      },
    },
    showTip: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isShowCancel: {
      type: Boolean,
      default() {
        return true;
      },
    },
    buttonTip: {
      type: String,
      default() {
        return '确 定';
      },
    },
    cancelButtonTip: {
      type: String,
      default() {
        return '取 消';
      },
    },
    modalAppendToBody: {
      /* 控制是否将弹框插入至 body 元素中。嵌套的表格如果插入至 body 元素中，将不会被遮挡 */
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    visible: {
      get() {
        return this.centerDialogVisible;
      },
      set(val) {
        // 当visible改变的时候，触发父组件的 updateVisible方法，在该方法中更改传入子组件的 centerDialogVisible的值
        this.$emit('updateVisible', val);
      },
    },
  },
  methods: {
    Cancel() {
      this.$emit('resetPopupData');
    },
    Save() {
      this.$emit('submitPopupData'); //
    },
  },
};
</script>
<!-- <style lang="scss">
.el-dialog.is-fullscreen .el-dialog__body {
  display: flex;
  flex-flow: column;
  height: calc(100vh - 120px);
}
</style> -->
<style lang="scss" scoped>
.commonn_dialog {
  .show-line {
    display: flex;
    align-items: center;
    margin-top: -9px;
  }
  .el-dialog__header {
    padding: 10px 20px;
    border-bottom: 1px solid #ededed;
    // box-shadow: 0px 4px 4px -4px #d1d0d0;
    background: #f5f5f5;
    font-size: 0;
    /* line-height: 1; */
    /* height: 18px; */
    height: 40px;
    line-height: 40px;
    span {
      font-size: 14px;
      color: #333;

      img {
        width: 18px;
        height: 18px;
        float: left;
        margin-right: 10px;
      }
    }
  }
  .dialog-footer {
    button + button {
      margin-left: 30px !important;
    }
  }
  .el-dialog__title {
    font-size: 16px;
    letter-spacing: 1px;
    color: #464646;
    font-weight: bolder;
  }
  .el-dialog__footer {
    // padding: 0px 20px 20px 0px;
    text-align: center;
  }
  .el-dialog__headerbtn {
    position: static; // 兼容IE11 ,取消原有的position定位
  }
  .el-dialog__close {
    // color: $header_bg;
    font-size: 20px;
    font-weight: bolder;
    position: absolute;
    top: -2px;
    right: 8px;
    &::after {
      content: '';
      //   border: 2px solid $header_bg;
      width: 20px;
      height: 20px;
      border-radius: 25px;
      position: absolute;
      right: -2px;
      top: -3px;
    }
  }
  .el-dialog__body {
    padding: 30px 20px;
  }
  .tip-wrap {
    color: #999;
    font-size: 14px;
    margin-top: 20px;
  }
  .el-button {
    min-width: 80px;
    height: 30px;
    padding: 0 10px;
    border-radius: 0;
  }
  .el-button--primary {
    background-color: #2587ff;
    /*width: 80px;*/
    height: 30px;
    &:hover,
    :active {
      background-color: #126edf;
    }
  }
  .cancel {
    &:hover,
    :active {
      border: 1px solid #2587ff;
      color: #2587ff;
      background: #f5f5f5;
    }
  }
  ::v-deep .el-date-picker {
    width: 200px !important;
  }
}
</style>
